import React, { useState } from 'react';
import './InvoiceState.css';
import { Select } from 'antd';
const { Option } = Select;
export const InvoiceState = ({ text, record, updateRecord }) => {
    const [currentState, setCurrentState] = useState(text);
    const handleSelectChange = (record, value, fields_to_update) => {
        updateRecord({ entity_id: record.id, fields_to_update });
        setCurrentState(value);
    };
    const getColorClassByValue = (value) => {
        if (value === 'pending-approval')
            return 'yellow-select';
        if (value === 'approved')
            return 'green-select';
        return 'red-select';
    };
    return (React.createElement(Select, { value: currentState, className: `${getColorClassByValue(currentState)}`, style: { width: 256 }, variant: "borderless", onChange: (value) => handleSelectChange(record, value, { state: value }) },
        React.createElement(Option, { value: 'pending-approval' }, "Pending approval"),
        React.createElement(Option, { value: 'missing-info' }, "Missing info"),
        React.createElement(Option, { value: 'approved' }, "Approved")));
};
